import React, { useState, useEffect } from 'react';
import { Typography, TextField, Button, Paper, Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import api from '../../services/api';

const DefinirMensagemConfirmacao = () => {
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { id } = useParams(); // ID da instituição

  useEffect(() => {
    const fetchMensagem = async () => {
      try {
        const response = await api.get(`/instituicoes/${id}`);
        setMensagem(response.data.mensagemConfirmacao || '');
      } catch (error) {
        setError('Erro ao carregar a mensagem de confirmação.');
        console.error(error);
      }
    };

    fetchMensagem();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.patch(`/instituicoes/${id}/mensagem-confirmacao`, { mensagemConfirmacao: mensagem });
      alert('Mensagem de confirmação atualizada com sucesso!');
    } catch (error) {
      setError('Erro ao atualizar a mensagem de confirmação.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Definir Mensagem de Confirmação
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          label="Mensagem de Confirmação"
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
          margin="normal"
        />
        <Button 
          type="submit" 
          variant="contained" 
          color="primary"
          disabled={loading}
        >
          {loading ? 'Salvando...' : 'Salvar Mensagem'}
        </Button>
      </Box>
    </Paper>
  );
};

export default DefinirMensagemConfirmacao;